// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__3_6AO","breadcrumbLink":"Breadcrumb_breadcrumbLink__33F5M","currentLink":"Breadcrumb_currentLink__3uUn3","divider":"Breadcrumb_divider__1R4Yn"};